import { useTranslation } from 'react-i18next';

/** Help, keyboard hints and what is recorded about a sign-in. */
export function AccountsFooter() {
  const { t } = useTranslation();
  return (
    <div className="acc-foot">
      <span>{t('accounts.foot.help')}</span>
      <span className="row">
        <span className="acc-kbd">{t('accounts.foot.enter')}</span>
        <span>{t('accounts.foot.confirm')}</span>
        <span className="acc-kbd">Esc</span>
        <span>{t('accounts.foot.back')}</span>
      </span>
      <p className="acc-legal">{t('accounts.foot.legal')}</p>
    </div>
  );
}
